// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1XljN","buttons":"SendReceipts_buttons__Jee1E","email":"SendReceipts_email__tNt_n","bookApptTitle":"SendReceipts_bookApptTitle__3WrOx"};